exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error{position:relative;margin-bottom:10px;padding-left:20px;padding-right:20px;text-align:left;background-color:#fff}.error:last-child .error-link,.error:last-child .error-static{margin-bottom:0}.error-text{margin:50px auto;line-height:1.25rem;font-size:1rem;font-weight:400;text-align:left}.error-border-bottom{width:100%;margin-top:30px;padding-bottom:40px;border-bottom:2px solid #eee}.error-button-container{margin-bottom:75px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Error/Error.scss
 ** module id = 1196
 ** module chunks = 0
 **/